import moment from "moment";
import { Span, Table } from "@tblabs/truffle";
import { Page } from "./Page";
import { ApplysRepo } from "../Services/ApplysRepo";
import { Panel } from "../Components/Panel";
import { InfoBox } from "../Components/InfoBox";


export class AdminApplyViewPage extends Page
{
    constructor(private _applys: ApplysRepo, private applyId: string)
    {
        const shortId = applyId.slice(-7).toUpperCase();

        super("Aplikacja #" + shortId);

        this.Content(async () =>
        {
            const applicant = await this._applys.Get(this.applyId);

            this.body.Append(
                new Panel(`Aplikacja na stanowisko: ${applicant.Position}`, [
                    new Span("Z dnia " + moment(applicant.CreatedAt).format("DD.MM.YYYY")).FontSize(16).Color("#ccc"),
                ]),
                new Panel("Odpowiedzi kandydata", [
                    ...applicant.Answers.Items
                        .map(x => new InfoBox(x.Question.value, x.Answer.value, "#f8f8f8")),
                ]),
                new Panel("Dane kontaktowe kandydata", [
                    new Table([], [
                        ["Imię", applicant.Recruit.Name.value],
                        ["Tel.", applicant.Recruit.Phone.value],
                        ["Mail", applicant.Recruit.Email.value],
                        ["Miasto", applicant.Recruit.City.value],
                    ]).Class("uk-table"),
                ])
            );
        });
    }
}
